// ABOUTME: Single-choice pill bar: a 40px dark track holding 32px options, the active one a fully
// ABOUTME: rounded white chip. Shared by the purchase advice filters and the onboarding page.

import { ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

// options: [{ value, label }] with the label already translated.
// fullWidth stretches the bar over its container with equal options; off, it hugs its content.
// solid paints the track in the dark panel colour itself, for a bar on a light page; off, the
// track is a translucent tint meant for a bar that already sits on a dark panel.
const ShPillFilter = ({ options, value, onChange, fullWidth = true, solid = false, sx }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isDark = theme.palette.mode === "dark";
    const track = solid
        ? (isDark ? colors.grey[500] : colors.txt['primary'])
        : (isDark ? colors.txt['softenedEvenMore'] : colors.txt['softenedMore']);

    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={(event, next) => {
                // Clicking the active option hands back null; the current choice stays.
                if (next !== null) {
                    onChange(next);
                }
            }}
            sx={{
                width: fullWidth ? 1 : "auto",
                height: 40,
                px: 0.5,
                py: 0.5,
                borderRadius: 5,
                background: track,
                "& .MuiToggleButtonGroup-grouped": {
                    m: 0,
                    border: 0,
                    borderRadius: "16px",
                },
                ...sx,
            }}
        >
            {options.map((option) => (
                <ToggleButton
                    key={String(option.value)}
                    value={option.value}
                    sx={{
                        flex: fullWidth ? 1 : "0 0 auto",
                        height: 32,
                        px: 1.5,
                        py: 0,
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 14,
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                        textTransform: "unset",
                        color: colors.txt['light'],
                        transition: "150ms",
                        "&:hover": { background: "rgba(255,255,255,.15)" },
                        "&.Mui-selected, &.Mui-selected:hover": {
                            background: "#fff",
                            color: theme.palette.mode === "dark" ? colors.txt['primaryDark'] : colors.txt['primary'],
                            fontWeight: 700,
                        },
                    }}
                >
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default ShPillFilter;
